export default __webpack_public_path__ + "static/media/apollo_1.e705c4bf.jpg";